import Head from 'next/head'
import Link from 'next/link'
import { useRouter } from 'next/router'
import PropTypes from 'prop-types'
import React from 'react'

import styles from './breadcrumbs.module.scss'

export const Breadcrumbs = ({ breadcrumbs, hasMaxWidth = false }) => {
  const router = useRouter()

  return (
    <>
      <Head>
        {breadcrumbs.length > 0 && (
          <script type="application/ld+json">
            {`
              {
                "@context": "https://schema.org",
                "@type": "BreadcrumbList",
                "itemListElement": [${breadcrumbs.map((breadcrumb, index) => {
                  return JSON.stringify({
                    '@type': 'ListItem',
                    position: `${index + 1}`,
                    name: `${breadcrumb.title}`,
                    item: `https://www.leaseloco.com${breadcrumb.slug ? breadcrumb.slug : router.asPath.split('?')[0]}`,
                  })
                })}]
              }
            `}
          </script>
        )}
      </Head>
      <nav aria-label="breadcrumb">
        <ol className={`${styles.list} ${hasMaxWidth ? styles['has-max-width'] : ''}`}>
          {breadcrumbs.map((crumb, index) => {
            if (!crumb.slug) {
              return (
                <li
                  className={styles['breadcrumb-item']}
                  aria-current="page"
                  key={crumb.title ? crumb.title : index}>
                  {crumb.title}
                </li>
              )
            }

            return (
              <li
                className={styles['breadcrumb-item']}
                key={crumb.title ? crumb.title : index}>
                <Link href={crumb.slug}>
                  <a>{crumb.title}</a>
                </Link>
              </li>
            )
          })}
        </ol>
      </nav>
    </>
  )
}

Breadcrumbs.propTypes = {
  breadcrumbs: PropTypes.array.isRequired,
  hasMaxWidth: PropTypes.bool,
}
